import { connect } from 'react-redux';

import NoGroupsPlaceholder from './NoGroupsPlaceholder';

import { currentUser } from '../../../../../core/selectors/user';
import { isInstructor } from '../../../../../core/selectors/classroom';

const mapStateToProps = (state) => {
  const user = currentUser(state);
  const isEducator = isInstructor(state, user.objectId);

  return { isEducator };
};

export default connect(mapStateToProps)(NoGroupsPlaceholder);
